import { hasAnalyticsConsent } from './cookieConsent'

export type PaymentSuccessfulPaymentType = 'shipping' | 'return' | 'legacy_shipping' | 'legacy_return'

export interface TrackPaymentSuccessfulParams {
  packageId?: string
  value?: number
}

const SESSION_DEDUPE_PREFIX = 'ga_payment_successful:'
const GA_MEASUREMENT_ID = 'G-YNE040M5JR'

function buildDedupeKey(params: TrackPaymentSuccessfulParams): string {
  const id = params.packageId ?? 'none'
  return `${SESSION_DEDUPE_PREFIX}:${id}`
}

/**
 * Sends GA4 event `payment_successful` when analytics consent is granted.
 * Deduplicates per browser session per paymentType + packageId (or route for legacy).
 */
export function trackPaymentSuccessful(params: TrackPaymentSuccessfulParams): void {
  if (typeof window === 'undefined') return
  if (!hasAnalyticsConsent()) return
  if (typeof window.gtag !== 'function') return

  const dedupeKey = buildDedupeKey(params)
  try {
    if (sessionStorage.getItem(dedupeKey)) return
    sessionStorage.setItem(dedupeKey, '1')
  } catch {
    // sessionStorage unavailable — still send event once
  }

  const payload: Record<string, string | number> = {}
  if (params.packageId) {
    payload.package_id = params.packageId
  }
  if (params.value !== undefined && Number.isFinite(params.value)) {
    payload.value = Math.round(params.value * 100) / 100
  }

  window.gtag('event', 'payment_successful', payload)
}

/**
 * Bind or clear GA4 user_id for cross-device attribution.
 * Pass null on logout to clear.
 */
export function setAnalyticsUserId(userId: string | null): void {
  if (typeof window === 'undefined') return
  if (!hasAnalyticsConsent()) return
  if (typeof window.gtag !== 'function') return

  if (userId) {
    window.gtag('config', GA_MEASUREMENT_ID, { user_id: userId })
  } else {
    window.gtag('config', GA_MEASUREMENT_ID, { user_id: undefined })
  }
}
